module.exports = __webpack_public_path__ + "media/images/smart_phone/icons/ＴＯＰメニューへ-20d67fd293878856ebcfdaba856b6ecb.png";